<template>
   <common-dialog-form
      :title="`${editing ? 'Edit' : 'Add'} Religion`"
      @close="$emit('close')"
      @submit="form => $emit('submit', {form, religion})"
      :visible="true"
   >
      <input-field
         v-model="religion.name"
         type="editable-select"
         label="Religion"
         :options="religionOptions"
         :errors="[]"
         required
      />
      <input-field
         label="Percentage"
         type="number"
         v-model="religion.percent"
         :errors="[]"
         :exta-attributes="{min: 0, max: 100, step: 0.001}"
         required
      />
   </common-dialog-form>
</template>

<script>
import CommonDialogForm from '@/components/organisms/Home/CommonDialogForm';
import InputField from '@/components/molecules/Login/InputField';

export default {
   name: 'ReligionForm',
   components: {
      CommonDialogForm,
      InputField,
   },
   props: {
      editing: {
         type: Boolean,
         default: () => false,
      },
      populateWith: {
         type: Object,
         default: () => ({empty: true}),
      },
   },
   data()
   {
      return {
         religion: {
            id: null,
            name: '',
            percent: 0,
         },
         religionOptions: [
            { title: "Islam", value: 'Islam'},
            { title: "Hinduism", value: 'Hinduism'},
            { title: "Buddhism", value: 'Buddhism'},
            { title: "Sikhism", value: 'Sikhism'},
            { title: "Judaism", value: 'Judaism'},
            { title: "Christianity", value: 'Christianity'},
         ],
      };
   },
   created()
   {
      if (this.editing)
      {
         this.religion = JSON.parse(JSON.stringify(this.populateWith));
      }
   }
};
</script>
